import { render, staticRenderFns } from "./AegEndorsementTransactionsList.vue?vue&type=template&id=7e273e48"
import script from "./AegEndorsementTransactionsList.vue?vue&type=script&lang=js"
export * from "./AegEndorsementTransactionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports